import { PageLayout } from '@bpm-web-app/components';
import { GiveawayDetail } from '@bpm-web-app/components/pages';

const GiveawayDetailPage = () => (
    <PageLayout>
        <GiveawayDetail />
    </PageLayout>
);

export default GiveawayDetailPage;
